import Vue from 'vue'
import Router from 'vue-router'
import Overview from "./views/Overview";
import Design from "./views/Design";
import Login from "./views/Login";

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {path: '/login', component: Login},
    {path: '/overview', component: Overview},
    {path: '/designs/:id', component: Design, name: 'design'},
    {path: '*', redirect: '/overview'}
  ]
})
